import { VerifyPatient } from "@/types/payment-link";
import { BookingFeeCollectionMethod } from "@/types/tenant";

import {
  collectBookingFee,
  createPayinConfigBookingFee,
  fetchPaymentLink,
  regeneratePayinConfig,
  verifyPatient,
} from "./payment-link";

export const paymentLinkQueryKeys = {
  all: ["payment-link"] as const,
  byToken: (token: string, isSurcharged: boolean) =>
    [...paymentLinkQueryKeys.all, "by-token", token, isSurcharged] as const,
};

export const paymentLinkQueryOptions = {
  byToken: (token: string, isSurcharged: boolean = false) => ({
    queryKey: paymentLinkQueryKeys.byToken(token, isSurcharged),
    queryFn: () => fetchPaymentLink(token, isSurcharged),
  }),
};

export const paymentLinkMutationOptions = {
  verifyPatient: () => ({
    mutationFn: (verifyPatientData: VerifyPatient) =>
      verifyPatient(verifyPatientData),
  }),
  createPayinConfigBookingFee: () => ({
    mutationFn: (variables: {
      eventId: string;
      patientId: string;
      isSurcharged: boolean;
    }) =>
      createPayinConfigBookingFee(
        variables.eventId,
        variables.patientId,
        variables.isSurcharged,
      ),
  }),
  collectBookingFee: () => ({
    mutationFn: (variables: {
      eventId: string;
      patientId: string;
      method: BookingFeeCollectionMethod;
      creatorId: string;
    }) =>
      collectBookingFee(
        variables.eventId,
        variables.patientId,
        variables.method,
        variables.creatorId,
      ),
  }),
  regeneratePayinConfig: () => ({
    mutationFn: (variables: {
      token: string;
      isSurcharged: boolean;
      savePaymentMethod?: boolean;
    }) =>
      regeneratePayinConfig(
        variables.token,
        variables.isSurcharged,
        variables.savePaymentMethod,
      ),
  }),
};
